import { ExternalLink, Sparkles, UsersRound } from "lucide-react";
import { useUiLanguage } from "./i18n/UiLanguageContext";

export default function DemoParticipantInfoPanel({
  experience,
}: {
  experience: "collaboration" | "liveQuiz";
}) {
  const { t } = useUiLanguage();
  const detailKey = experience === "collaboration"
    ? "demo.participantInfo.collaboration"
    : "demo.participantInfo.liveQuiz";
  const hubMode = experience === "collaboration" ? "collab" : "quiz";

  return (
    <aside
      data-testid={`demo-participant-info-${experience}`}
      className="mt-5 rounded-3xl border border-violet-200/90 bg-gradient-to-br from-violet-50 via-white to-emerald-50 p-4 text-left shadow-sm"
      aria-label={t("demo.participantInfo.heading")}
    >
      <div className="flex items-start gap-3">
        <div className="grid h-10 w-10 shrink-0 place-items-center rounded-2xl bg-gradient-to-br from-violet-600 to-fuchsia-500 text-white shadow-sm">
          <UsersRound aria-hidden="true" size={20} />
        </div>
        <div>
          <h2 className="text-sm font-black text-slate-950">{t("demo.participantInfo.heading")}</h2>
          <p className="mt-1 text-sm leading-6 text-slate-700">{t(detailKey)}</p>
        </div>
      </div>

      <div className="mt-4 flex flex-col gap-2 sm:flex-row sm:flex-wrap">
        <a
          href="/register"
          target="_blank"
          rel="noopener noreferrer"
          className="inline-flex min-h-11 items-center justify-center gap-2 rounded-xl bg-gradient-to-r from-emerald-600 to-teal-500 px-4 py-2.5 text-sm font-black text-white shadow-sm transition hover:brightness-105 focus:outline-none focus:ring-4 focus:ring-emerald-100"
        >
          <Sparkles aria-hidden="true" size={16} />
          {t("demo.participantInfo.teacherAction")}
          <ExternalLink aria-hidden="true" size={14} />
        </a>
        <a
          href={`/student?mode=${hubMode}`}
          target="_blank"
          rel="noopener noreferrer"
          className="inline-flex min-h-11 items-center justify-center gap-2 rounded-xl border border-slate-300 bg-white px-4 py-2.5 text-sm font-black text-slate-800 transition hover:bg-slate-50 focus:outline-none focus:ring-4 focus:ring-violet-100"
        >
          {t("demo.participantInfo.studentAction")}
          <ExternalLink aria-hidden="true" size={14} />
        </a>
      </div>
    </aside>
  );
}
